export default "__VITE_ASSET__BLpdVROa__"